export const IComponentViewModelType = Symbol('IComponentViewModel');
